import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";

import { useDrizzleContext } from "../drizzle/drizzleContext";

import crypto from 'crypto-js';

import * as LoginActions from './actions';

import SignupPage from './SignupPage';

const SignupContainer = ({
  dispatch,
  contracts,
  accounts,
  transactions,
  transactionStack,
  blockTxHash,
  accountChanged,
  granting,
  willCommit,
  committing
}) => {
  const drizzle = useDrizzleContext();
  const contract = drizzle.contracts.THDJabraToken;

  const [ userInfo, setUserInfo ] = useState({
    userIdDigest: null,
    passwordDigest: null
  });
  const [ correctUsername, setCorrectUsername ] = useState(true);
  const [ correctPassword, setCorrectPassword ] = useState(true);
  const [ signupConfirms, setSignupConfirms ] = useState(false);
  const [ signupConfirming, setSignupConfirming ] = useState(false);

  const [ stackId, setStackId ] = useState(null);

  const [ data, setData ] = useState({ emailAddress: "", password: "" });

  const [ savedAccount, setSavedAccount ] = useState(accounts[0]);
  const [ dataKey, setDataKey ] = useState(null);
  const [ checkBalanceSynced, setCheckBalanceSynced ] = useState(true);
  const encryptedJson = {
    "version": 3,
    "id": "5301c8ce-4213-436f-af5d-06b6a2ef505a",
    "address": "1392ef24b278f91db7f9c1f0edbe902736d0dd63",
    "crypto": {
      "ciphertext": "f03d77562cc066bbd328616d5c03144006a45faa92238a88d7b2b7c6db26f7b9",
      "cipherparams": {
        "iv": "814087276f901480e38cfc1a872d652f"
      },
      "cipher": "aes-128-ctr",
      "kdf": "scrypt",
      "kdfparams": {
        "dklen": 32,
        "salt": "fda66b98fcd52a98083d534b00c37614616e08f1c794dcf8605e8f4b6c5e7b30",
        "n": 8192,
        "r": 8,
        "p": 1
      },
      "mac": "8d74dcc1ff9facd1f07b7676850b0a8739c209d9c6872b56c979a3cdc4e4ccdf"
    }
  };
  const word = "F2DD0437342FA4AE2A0065C34AA2996E";
  const key = crypto.enc.Utf8.parse("d12db5e677e56d8cc075c3cda3e6a77ab3e506e1e07c6ce415a5407ef08ac0a5");
  const iv = crypto.enc.Utf8.parse("09cbf27d9cb1b3eb34910337256ae09cd46c36d28fd878bca973bbf9b3657d2d");

  /*const encryptedJson = {
    version: 3,
    id: 'f36c0bee-4540-4f65-81e1-e37a3abffb76',
    address: '220e9eeacbcd69f6a45f7a9fe007cc2049ff2666',
    crypto: {
      ciphertext: '2353087b9a383bfd997f210c37dcb7356666b798d7910431d083f406bae13a68',
      cipherparams: { iv: '0209457b26462251419d10d5f9fe8a51' },
      cipher: 'aes-128-ctr',
      kdf: 'scrypt',
      kdfparams: {
        dklen: 32,
        salt: '955d579ccf8a17084773f587c0d6f1cc5046bcfef077088a4ccf70a23de53d52',
        n: 8192,
        r: 8,
        p: 1
      },
      mac: '57c6e62d73a771caf3f5ebf8a6112480dab91ce2492192674eb09a1ed5f70989'
    }
  };
  const word = "F2DD0437342FA4AE2A0065C34AA2996E";
  const key = crypto.enc.Utf8.parse("d12db5e677e56d8cc075c3cda3e6a77ab3e506e1e07c6ce415a5407ef08ac0a5");
  const iv = crypto.enc.Utf8.parse("09cbf27d9cb1b3eb34910337256ae09cd46c36d28fd878bca973bbf9b3657d2d");*/

  const Decrypt = () => {
    const encryptedHexStr = crypto.enc.Hex.parse(word);
    const srcs = crypto.enc.Base64.stringify(encryptedHexStr);
    const decrypt = crypto.AES.decrypt(srcs, key, { iv: iv, mode: crypto.mode.CBC, padding: crypto.pad.Pkcs7 });
    const decryptedString = decrypt.toString(crypto.enc.Utf8);
    return decryptedString.toString();
  };

  const handleConfirmSubmit = () => {
    setSignupConfirms(true);
    setSignupConfirming(false);
  };

  const handleCancelSubmit = () => {
    setSignupConfirms(false);
    setSignupConfirming(false);
  };

  const handleChange = e => {
    setData({...data, [e.target.name]: e.target.value});
  };

  const handleSubmit = e => {
    e.preventDefault();

    if (data.emailAddress === "" || data.password === "" || data.altPassword === "") {
      return;
    }

    if (data.password !== data.altPassword) {
      setCorrectPassword(false);
      return;
    }

    if ((data.emailAddress).includes('@'))
      setCorrectUsername(true);
    else {
      setCorrectUsername(false);
      return;
    }

    const userId = data.emailAddress.split('@')[0];
    const domainname = "ml.tanaka.co.jp";
    const password = data.password;
    setCorrectPassword(true);

    setUserInfo({
      userIdDigest: drizzle.web3.utils.sha3(userId),
      passwordDigest: drizzle.web3.utils.sha3(password),
      domainnameDigest: drizzle.web3.utils.sha3(domainname)
    });
    setSignupConfirming(true);
    e.target.reset();
  };

  useEffect(() => {
    if ((userInfo.userIdDigest === null && userInfo.passwordDigest === null) || !signupConfirms)
      return;

    initializeAccount();
  }, [signupConfirms]);

  const initializeAccount = async () => {
    var _dataKey = await contract.methods.checkBalance.cacheCall(savedAccount);

    setDataKey(_dataKey);
  };

  useEffect(async () => {
    if (granting || willCommit || committing || dataKey === null)
      return;

    const isBalance = contracts.THDJabraToken.checkBalance[dataKey]
      ? contracts.THDJabraToken.checkBalance[dataKey].value
      : null

    if (isBalance === null)
      return;

    if (isBalance) {
      var pk = drizzle.web3.eth.accounts.decrypt(encryptedJson, Decrypt());
      await drizzle.web3.eth.accounts.wallet.add(pk.privateKey);
      pk = null;
      setDataKey(null);
      dispatch(notifyChangedAddress(drizzle.web3))
    } else {
      setDataKey(null);
      dispatch(willCommitSignup());
    }
  }, [dataKey, contracts]);

  useEffect(() => {
    if (!willCommit)
      return;

    commitSignup();
  }, [willCommit]);

  useEffect(async () => {
    if (!accountChanged)
      return;
    else if (accountChanged === 1)
      grantEth();
    else if (accountChanged === 2)
      commitSignup();
  }, [accounts]);

  const grantEth = async () => {
    const estimatedGas = await contract.methods.grantAtFirstAccess(
        savedAccount
      ).estimateGas({
        from: accounts[0]
    });
    
    const estimatedGasPrice = await drizzle.web3.eth.getGasPrice();
    const multiplicationFactor = 1.1;
    const gasPriceMultiplication = 1.1;
    const chainId = await drizzle.web3.eth.getChainId();

    const _stackId = await contract.methods["grantAtFirstAccess"].cacheSend(savedAccount, {
      from: accounts[0],
      gas: Math.floor(estimatedGas*multiplicationFactor),
      gasPrice: Math.floor(estimatedGasPrice*gasPriceMultiplication),
      chainId: chainId
    })
    dispatch(notifyGranting(_stackId));
    setStackId(_stackId);
  };

  const commitSignup = async () => {
    const estimatedGas = await contract.methods.commitSignup(
        userInfo.userIdDigest, userInfo.domainnameDigest, userInfo.passwordDigest
      ).estimateGas({
        from: accounts[0]
    });
    const estimatedGasPrice = await drizzle.web3.eth.getGasPrice();
    const multiplicationFactor = 1.1;
    const gasPriceMultiplication = 1.1;

    const _stackId = await contract.methods["commitSignup"].cacheSend(
      userInfo.userIdDigest, userInfo.domainnameDigest, userInfo.passwordDigest, {
      from: accounts[0],
      gas: Math.floor(estimatedGas*multiplicationFactor),
      gasPrice: Math.floor(estimatedGasPrice*gasPriceMultiplication),
    });
    dispatch(notifySigningUp(_stackId));
    setStackId(_stackId);
  };

  useEffect(() => {
    if (!granting || committing)
      return;

    const txHash = transactionStack[stackId];

    if (transactions[txHash] && transactions[txHash].status === 'success') {
      var pk = drizzle.web3.eth.accounts.decrypt(encryptedJson, Decrypt());
      drizzle.web3.eth.accounts.wallet.remove(pk.address);
      dispatch(notifyRecoverAddress(drizzle.web3));
      pk = null;

      dispatch(notifyGranted());
      return;
    }
  }, [transactions]);

  useEffect(() => {
    if (granting || !committing)
      return;

    const txHash = transactionStack[stackId];

    if (transactions[txHash] && transactions[txHash].status === 'success') {
      dispatch(notifySignedgUp());
      return;
    }
  }, [transactions]);

  return (
    <SignupPage
      signupConfirms={signupConfirms}
      signupConfirming={signupConfirming}
      correctUsername={correctUsername}
      correctPassword={correctPassword}
      handleConfirmSubmit={handleConfirmSubmit}
      handleCancelSubmit={handleCancelSubmit}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
    />
  );
}

const notifyGranting = stackId => {
  return {
    type: LoginActions.SIGNUP_GRANTING
  };
};

const notifyGranted = () => {
  return {
    type: LoginActions.SIGNUP_GRANTED
  };
};


const willCommitSignup = () => {
  return {
    type: LoginActions.SIGNUP_WILL_COMMIT
  }
}

const notifySigningUp = stackId => {
  return {
    type: LoginActions.SIGNUP_COMMITTING
  };
};

const notifySignedgUp = stackId => {
  return {
    type: LoginActions.SIGNUP_COMMITTED
  };
};

const notifyChangedAddress = web3 => {
  return {
    type: LoginActions.ACCOUNTS_CHANGED,
    web3: web3
  };
}

const notifyRecoverAddress = web3 => {
  return {
    type: LoginActions.ACCOUNTS_RECOVERED,
    web3: web3
  };
}

const mapStateToProps = state => ({
  contracts: state.contracts,
  accounts: state.accounts,
  transactions: state.transactions,
  transactionStack: state.transactionStack,
  blockTxHash: state.login.blockTxHash,
  accountChanged: state.login.accountChanged,
  granting: state.login.granting,
  willCommit: state.login.willCommit,
  committing: state.login.committing,
  granting: state.login.granting
});

export default connect(mapStateToProps)(SignupContainer);
